import { Output, EventEmitter, ElementRef, Directive, HostListener, ViewContainerRef, Input } from "@angular/core";

@Directive({
    selector: '[variableBackdrop]'
})

export class VariablePopperDirective {

  @Input()
  variableBackdrop: boolean;
  @Output()
  backdropClicked = new EventEmitter<ElementRef>();

  constructor(private referenceElement: ViewContainerRef) { }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.variableBackdrop && !this.referenceElement.element.nativeElement.contains(event.target)) {
      this.backdropClicked.emit();
    }
  }
}